// Sortable-Wrapper für ein Dashboard-Widget (nur im Bearbeiten-Modus aktiv).
//
// Nutzt @dnd-kit/sortable: rectSortingStrategy (im Dashboard gesetzt) reflowt
// ein wrappendes Grid mit unterschiedlich breiten Widgets sauber — anders als
// eine reine Listen-Reorder-Lib. Die Drag-Aktivierung hängt am Griff im
// Card-Header (dragHandleProps), nicht an der ganzen Card, damit Klicks aufs
// Optionsmenü weiterhin funktionieren.

import type { DashboardWidget } from "@juuplan/shared";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

interface Props {
  widget: DashboardWidget;
  /** Grid-Column-Span (2/3/4/6) für das Wrapper-Element. */
  span: number;
  /** Render-Prop: bekommt die Handle-Props für den Griff im Card-Header. */
  children: (dragHandleProps: Record<string, unknown>) => preact.JSX.Element;
}

export function SortableWidget(props: Props): preact.JSX.Element {
  const { widget, span, children } = props;
  const { setNodeRef, attributes, listeners, transform, transition, isDragging } =
    useSortable({ id: widget.id });

  const style = {
    transform: CSS.Translate.toString(transform),
    transition,
    "--juuplan-widget-span": span,
    // Original beim Ziehen abdimmen — die schwebende Kopie zeigt das DragOverlay.
    opacity: isDragging ? 0.4 : undefined,
    zIndex: isDragging ? 50 : undefined,
  } as preact.JSX.CSSProperties;

  const dragHandleProps: Record<string, unknown> = {
    ...(attributes as unknown as Record<string, unknown>),
    ...((listeners ?? {}) as unknown as Record<string, unknown>),
  };

  return (
    <div
      ref={setNodeRef as (el: HTMLElement | null) => void}
      class="juuplan-widget-wrap"
      style={style}
    >
      {children(dragHandleProps)}
    </div>
  );
}
